import ScrubstrApiQueryService from '../ScrubstrApiQueryService/ScrubstrApiQueryService'

export class WithdrawClaimPageService {
  async withdraw(pageId: number, isAgency: boolean): Promise<void> {
    const api = new ScrubstrApiQueryService()
    await api.post({
      endpoint: `claim-pages/withdraw/${pageId}?isAgency=${isAgency}`,
    })
  }
}
